module.exports = __webpack_public_path__ + "img/Réalisation portail en biais.19629f9d.jpg";